import { mergeClassnames } from '@heathmont/moon-core-tw';
import useSite from '~/client/hooks/useSite';
import getPositionNumberColors from '../../utils/getPositionNumberColors';

type Props = {
  isMyScore?: boolean;
  size?: 'Default' | 'Small';
};

const PositionNumber: FC<Props> = ({ children, isMyScore, size }) => {
  const { isBitcasino } = useSite();
  return (
    <div
      className={mergeClassnames(
        'flex items-center justify-center rounded-3xl px-0.5 py-0 text-center font-medium',
        size === 'Small'
          ? 'h-[1.125rem] w-[1.125rem] text-moon-10'
          : 'h-6 w-6 text-moon-12',
        getPositionNumberColors(isMyScore, isBitcasino),
      )}
    >
      {children}
    </div>
  );
};
export default PositionNumber;
